import { render } from "./ListeNotificationRedevancePage.vue?vue&type=template&id=00d6d84f&ts=true"
import script from "./ListeNotificationRedevancePage.vue?vue&type=script&lang=ts"
export * from "./ListeNotificationRedevancePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__